<script setup>
import { ref, computed } from 'vue';
import BaseBubble from './Base.vue';
import Icon from 'next/icon/Icon.vue';
import { useMessageContext } from '../provider.js';

const emit = defineEmits(['error']);

const { attachments } = useMessageContext();

const attachment = computed(() => attachments.value[0]);

const hasError = ref(false);

const handleError = () => {
  hasError.value = true;
  emit('error');
};
</script>

<template>
  <!--
    Un sticker se muestra sin fondo de burbuja: con el fondo se lee como una
    foto adjunta y no como un sticker. Tampoco abre la galería, porque los
    stickers no forman parte de los medios de la conversación.
  -->
  <BaseBubble class="!bg-transparent" data-bubble-name="sticker">
    <div v-if="hasError" class="flex items-center gap-1">
      <Icon icon="i-lucide-circle-off" class="text-n-slate-11" />
      <p class="mb-0 text-n-slate-11">
        {{ $t('COMPONENTS.MEDIA.IMAGE_UNAVAILABLE') }}
      </p>
    </div>
    <img
      v-else
      class="object-contain w-32 h-32 skip-context-menu"
      :src="attachment.dataUrl"
      :alt="$t('CONVERSATION.STICKERS.BUBBLE_ALT')"
      @error="handleError"
    />
  </BaseBubble>
</template>
